import axios from 'axios';

/*
*  This file contains all axios calls related add contacts to automation
*/

const urlBase = '/app/text-voice-then';

export const getAccountPhoneNumberInfo = () => {
    return axios.get(`${urlBase}/account-phone-number`);
};

export const getAutomationMessageInfo = (automationMessageId) => {
    return axios.get(`${urlBase}/${automationMessageId}`);
};

export const createAutomationMessage = (payload) => {
    return axios.post(urlBase, payload);
};

export const updateAutomationMessage = (payload) => {
    return axios.put(urlBase, payload);
};
